<script setup>
import { ref } from 'vue'
import lang from '@/pages/global/verifyMetaData/lang.json'

const defaultLocal =
  navigator.language === 'zh-TW' ? 'zh-TW' : navigator.language.split('-')[0]
const local = ref(defaultLocal)
const languages = new Proxy(lang, {
  get: function (target, property) {
    if (target[property]) {
      return target[property][local.value] || target[property].en
    }
    return ''
  }
})
</script>

<template>
  <div class="error-status-wrapper">
    <div class="title">{{ languages.i_data_missing }}</div>
    <div class="text">{{ languages.i_photo_taken_offline }}</div>
  </div>
</template>

<style scoped lang="scss">
.error-status-wrapper {
  margin-top: 20px;
  border-radius: 10px;
  background: #faf0f0;
  padding-bottom: 30px;

  .title {
    margin-bottom: 20px;
    font-weight: 590;
    font-size: 16px;
    padding: 16px 20px;
    border-bottom: 0.5px solid rgba(204, 163, 163, 1);
    color: rgba(153, 61, 61, 1);
  }

  .text {
    padding: 16px 20px;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
  }
}
</style>
